// @ts-ignore
/* eslint-disable */
import { getCurrentAdminUserAuthzApiAdminUsersMeAuthzGet } from './generated/adminUser';
import {
  assignRolePermissionsApiApiAdminRbacRolesRoleIdPermissionsPut,
  createAdminRoleApiApiAdminRbacRolesPost,
  deleteAdminRoleApiApiAdminRbacRolesRoleIdDelete,
  getRolePermissionsApiApiAdminRbacRolesRoleIdPermissionsGet,
  listAdminRolesApiAdminRbacRolesGet,
  listPermissionsApiAdminRbacPermissionsGet,
  syncPermissionsApiApiAdminRbacPermissionsSyncPost,
  updateAdminRoleApiApiAdminRbacRolesRoleIdPut,
} from './generated/rbac';

/**
 * 查询后台角色列表（分页）
 * GET /api/admin/rbac/roles
 */
export async function listAdminRoles(
  params?: API.listAdminRolesApiAdminRbacRolesGetParams,
  options?: { [key: string]: any },
) {
  return listAdminRolesApiAdminRbacRolesGet(params ?? {}, options);
}

/**
 * 创建后台角色
 * POST /api/admin/rbac/roles
 */
export async function createAdminRole(
  body: API.CreateAdminRoleRequest,
  options?: { [key: string]: any },
) {
  return createAdminRoleApiApiAdminRbacRolesPost(body, options);
}

/**
 * 更新后台角色
 * PUT /api/admin/rbac/roles/:role_id
 */
export async function updateAdminRole(
  roleId: string,
  body: API.UpdateAdminRoleRequest,
  options?: { [key: string]: any },
) {
  return updateAdminRoleApiApiAdminRbacRolesRoleIdPut(
    { role_id: roleId },
    body,
    options,
  );
}

/**
 * 删除后台角色
 * DELETE /api/admin/rbac/roles/:role_id
 */
export async function deleteAdminRole(
  roleId: string,
  options?: { [key: string]: any },
) {
  return deleteAdminRoleApiApiAdminRbacRolesRoleIdDelete(
    { role_id: roleId },
    options,
  );
}

/**
 * 查询权限点目录
 * GET /api/admin/rbac/permissions
 */
export async function listAdminPermissions(
  params?: API.listPermissionsApiAdminRbacPermissionsGetParams,
  options?: { [key: string]: any },
) {
  return listPermissionsApiAdminRbacPermissionsGet(params ?? {}, options);
}

/**
 * 同步前端权限点清单（Manifest）
 * POST /api/admin/rbac/permissions/sync
 */
export async function syncPermissionManifest(
  permissions: API.PermissionManifestItem[],
  options?: { [key: string]: any },
) {
  return syncPermissionsApiApiAdminRbacPermissionsSyncPost(
    { permissions },
    options,
  );
}

/**
 * 获取当前用户授权信息（角色、权限 key 列表等）
 * GET /api/admin/users/me/authz
 */
export async function getCurrentUserAuthz(options?: { [key: string]: any }) {
  return getCurrentAdminUserAuthzApiAdminUsersMeAuthzGet(options);
}

/**
 * 获取角色已分配权限（用于回显与编辑）
 * GET /api/admin/rbac/roles/:role_id/permissions
 */
export async function getRolePermissions(
  roleId: string,
  options?: { [key: string]: any },
) {
  return getRolePermissionsApiApiAdminRbacRolesRoleIdPermissionsGet(
    { role_id: roleId },
    options,
  );
}

/**
 * 覆盖设置角色权限点
 * PUT /api/admin/rbac/roles/:role_id/permissions
 */
export async function assignRolePermissions(
  roleId: string,
  permKeys: string[],
  options?: { [key: string]: any },
) {
  return assignRolePermissionsApiApiAdminRbacRolesRoleIdPermissionsPut(
    { role_id: roleId },
    { perm_keys: permKeys },
    options,
  );
}
